var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\t"+_vm._s(_vm.column.numberPrefix)+_vm._s(_vm.getValue)+_vm._s(_vm.column.numberSuffix)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }